import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { isImpersonating } from 'utils/impersonationSession';
import { getShowcaseUrl } from '../components/Tools/getShowcaseUrl';

export const GENERATE_EXCHANGE_TOKEN = gql`
  mutation GenerateExchangeToken($duration: Int!) {
    generateExchangeToken(duration: $duration) {
      token
      showcaseUrl
    }
  }
`;

export const useShowcaseLogin = () => {
  const [generateExchangeToken, { loading: tokenLoading }] = useMutation(
    GENERATE_EXCHANGE_TOKEN,
  );

  const handleShowcaseLogin = async () => {
    try {
      const response = await generateExchangeToken({
        variables: { duration: 600 },
      });
      const exchangeTokenResponse = response.data?.generateExchangeToken;
      if (exchangeTokenResponse) {
        // Check if currently impersonating and add flag if needed
        const currentlyImpersonating = isImpersonating();
        const impersonationParam = currentlyImpersonating
          ? '&isImpersonation=true'
          : '';
        const showcaseUrl = `${getShowcaseUrl()}/token-exchange?exchangeToken=${
          exchangeTokenResponse.token
        }${impersonationParam}`;
        window.open(showcaseUrl, '_blank');
      }
    } catch (error) {
      throw new Error('Failed to create magic link for showcase login', {
        cause: error,
      });
    }
  };

  return {
    handleShowcaseLogin,
    tokenLoading,
  };
};
